export default function roundHalfUp(num: number, decimals = 0) {
  const factor = Math.pow(10, decimals);
  return (Math.sign(num) * Math.round(Math.abs(num) * factor)) / factor;
}
